module.exports = __webpack_public_path__ + "img/placehold_people.9f2c4ca5.png";